import SuspiciousTransactionResult from 'features/suspiciousTransaction/screens/SuspiciousTransactionResult/SuspiciousTransactionResult';
import React from 'react';

export default function SuspiciousTransactionPage() {
  return <SuspiciousTransactionResult />;
}
